const beneficiaryAgreementTemplate = `
<div class="modal-header">
    <h2 translate="app.beneficiary.agreement.heading"></h2>
</div>
<div class="modal-body modal-beneficiary-agreement">
    <p translate="app.beneficiary.agreement.text" translate-values="{ buttonText:beneCntrl.mainPageSubmitButtonName }"></p>
    <hr />
    <div class="text-right">
        <a class="btn btn-primary" ng-click="beneCntrl.dismiss();" translate="app.beneficiary.agreement.button"></a>
    </div>
</div>
`;
export default beneficiaryAgreementTemplate;